module.exports = __webpack_public_path__ + "media/images/iconPaginateLast--dark-fc5ef99af1e8b37911cc8f07d375439c.png";